module.exports = {
      id: "video-icon-usage",
      viewBox: "0 0 92 92",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#video-icon",
      toString: function () {
        return this.url;
      }
    }